// roles
export const GET_ROLES_REQUEST = 'GET_ROLES_REQUEST';
export const GET_ROLES_SUCCESS = 'GET_ROLES_SUCCESS';
export const GET_ROLES_FAILURE = 'GET_ROLES_FAILURE';
export const CLEAR_ROLES = 'CLEAR_ROLES';

// role names
export const ROLE_ADMIN = 'ADMIN';
export const ROLE_PART_MANAGER = 'PART_MANAGER';
export const ROLE_TASK_MANAGER = 'TASK_MANAGER';
export const ROLE_CLIENT_MANAGER = 'CLIENT_MANAGER';
export const ROLE_VEHICLE_MANAGER = 'VEHICLE_MANAGER';
export const ROLE_RATE_MANAGER = 'RATE_MANAGER';
